import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Cookies() {
  return (
    <div className="privacy">
      <div className="min-h-80vh px-4">
        <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block"><div className="breadcrumbs"><Link to="/">Home</Link><span className="px-2">/</span><span>Cookie Policy</span></div></div>
        <article className="cms-root_cmsFullWidth-5e3 cms-root-63a px-4"><div className="richContent-root-63a"><div className="row-contained-645 row-root-63a row-contained-inner"><div className="text-root-63a">
          <h1>Cookie Policy</h1>
          <p className="p1">Cookies are small files placed on your device when you visit a website. This policy explains the types failblossom may use and the choices available to you.</p>
          <h2>Strictly necessary cookies</h2>
          <p className="p1">These support core functions such as navigation, shopping-cart contents, checkout security, fraud prevention and remembering privacy choices. They cannot normally be switched off through our site.</p>
          <h2>Preference cookies</h2>
          <p className="p1">These remember choices such as region, currency and display preferences. You can decline them, but parts of the site may feel less personalised.</p>
          <h2>Analytics cookies</h2>
          <p className="p1">With consent, analytics cookies help us understand aggregate visits, page performance and how shoppers move through the site so we can improve it.</p>
          <h2>Marketing cookies</h2>
          <p className="p1">If used and accepted, these help measure campaigns and tailor advertising. We do not set non-essential cookies before receiving the consent required by applicable law.</p>
          <h2>Managing cookies</h2>
          <p className="p1">You can review or change non-essential cookie choices through the cookie settings shown on the site. You can also block or delete cookies in your browser; doing so may affect checkout or saved preferences.</p>
          <h2>Contact</h2>
          <p className="p1">Questions about cookies can be sent to <a href="mailto:level@failblossom.lifestyle">level@failblossom.lifestyle</a>.</p>
          <p className="p1"><strong>Last updated: 14 September 2026</strong></p>
        </div></div></div></article>
      </div>
    </div>
  );
}

export default Cookies;
